import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://cosgtbuykxzmoisdbrga.supabase.co';
const SUPABASE_ANON_KEY = 'sb_publishable_wDGFiO_NLfezywivY67ItQ_wGWC4psO';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
